export default __webpack_public_path__ + "static/media/DSC05839.e130deb9.jpg";